module.exports = __webpack_public_path__ + "static/media/internship-avatar-testimonies-3.09a0cb5f.webp";